import React from "react";
import "./DBTools.css";
import Footer from '../../componets/Footer'
import { useNavigate } from "react-router-dom";

import {
  House,
  Search,
  IndianRupee,
  PieChart,
  Map,
  MapPin,
  Layers,
  Monitor,
  Waves,
  Puzzle,
  Link,
  Plug,
  CloudRain,
  Droplets,
  ChevronRight,
  Plus,
  GitCompare,
  MapPinned,
} from "lucide-react";

export default function Dashboard() {
  const navigate = useNavigate();
  const handleClick = (item) => {
    if (item.id === 111) {
      navigate("/PropertyInfo");
    }
    else if (item.id === 112) {
      navigate("/IdentifiedProperty");
    }
    else if (item.id === 113) {
      navigate("/PropertyChangeMap2");
    }
    else if (item.id === 114) {
      navigate("/PropertyChangeMap3");
    }
    else if (item.id === 1141) {
      navigate("/dashboard?type=8");
    }
    else if (item.id === 115) {
      navigate(`/dashboard?type=7`);
    }
    else if (item.id === 116) {
      navigate("/MapNewProperty2");
    }
    else if (item.id === 117) {
      navigate("/KMLAnalysisComponent");
    }
    else if (item.id === 118) {
      navigate("/GisQueryAnalysis");
    }
    else if (item.id === 119) {
      navigate("/MapChangeAnalysis");
    }
    else if (item.id === 120) {
      navigate("/SCADAHome");
    }
    else if (item.id === 130) {
      navigate("/wtp-reports");
    }
    else if (item.id === 131) {
      navigate("/stp-reports");
    }
    else if (item.id === 121) {
      navigate("/SCADADashboard");

    }
    else if (item.id === 122) {
      navigate("/SCADAWTPDashboard");
    }
    else if (item.id === 123) {
      navigate("/MAPLayersUjjain");

    }
    else if (item.id === 124) {
      navigate("/ABPass");
    }

    else if (item.id === 125) {
      navigate("/abpass-validation");
    }
    else if (item.id === 126) {
      navigate("/floods-system");
    }
    else if (item.id === 127) {
      navigate("/MapPointDist");
    }


    else if (item.id === 128) {
      navigate("/MapLayerUjjain");
    }

    else if (item.id === 129) {
      navigate("/GISSearch");
    }



    else {

      // navigate(`/dashboard?type=${item.id}`);
      // alert(item.id);
      navigate(`/dashboard?type=115`);

    }
  };

  /* =========================
     CARDS DATA
     MAPLayersAll
  ========================= */

  const modules = [
    { title: "PM Gati Shakti", img: "/img/Project-cardshakti.png" },
    { title: "AMRUT 2.0", img: "/img/Projectamrut.png" },
    { title: "ABPAS", img: "/img/Projectcardabpas.png" },
    { title: "E-Nagar Palika", img: "/img/ProjectcardEpalika.png" },
    { title: "IGRS", img: "/img/Projectcardjan.png" },
    { title: "BMC-PMAY", img: "/img/Projectcardmap.png" },
    { title: "SBM Mission", img: "/img/Projectcardmission.png" },
    { title: "SAMPADA", img: "/img/Projectcardsam.png" },
    { title: "Smart City", img: "/img/Projectcardcity.png" },
    { title: "Ujjain Simhastha", img: "/img/Projectcardujjain.png" },

  ];


  const cards = [
    {
      color: "purple",
      icon: <House />,
      title: "Property Analysis",

      modules: [
        {
          id: 111,
          icon: <Search size={16} />,
          title: "Search Property",
          text: "Search and verify properties",
        },

        {
          id: 112,
          icon: <Plus size={16} />,
          title: "Identify New Property",
          text: "Register and map new ",
        },

        {
          id: 113,
          icon: <IndianRupee size={16} />,
          title: "Tax Paid / Unpaid Property",
          text: " Payment and pending taxes",
        },

        {
          id: 114,
          icon: <PieChart size={16} />,
          title: "Tax Evaluation Analysis",
          text: "Evaluate tax and trends......",
        },
        {
          id: 1141,
          icon: <Layers size={16} />,
          title: "Map Print by ULB",
          text: "Map with All Layers ......",
        },
      ],
    },

    {
      color: "green",
      icon: <Monitor />,
      title: "Monitoring Tools ",


      modules: [
        {
          id: 122,
          icon: <Waves size={16} />,
          title: "SCADA Water Network Monitoring",
          text: " Real-time utility systems.....",
        },
        {
          id: 120,
          icon: <Waves size={16} />,
          title: "SCADA Sewerage Network Monitoring",
          text: " Real-time utility systems.....",
        },
        {
          id: 130,
          icon: <Waves size={16} />,
          title: "WTP Reports",
        },
        {
          id: 131,
          icon: <Waves size={16} />,
          title: "STP Reports",
        },

      ],
    },

    {
      color: "blue",
      icon: <MapPinned />,
      title: "Planning  Tools",
      // desc: "Urban planning and GIS overlay analysis",

      modules: [
        {
          id: 115,
          icon: <Map size={16} />,
          title: "Buffer Analysis Property",
          text: "Analyze GIS buffers.....",
        },

        {
          id: 116,
          icon: <Layers size={16} />,
          title: "Master Plan Analysis",
          text: "Analyze master planning........",
        },

        {
          id: 117,
          icon: <MapPin size={16} />,
          title: "KML Overlay Analysis",
          text: "Overlay KML on GIS maps ......",
        },

        {
          id: 118,
          icon: <GitCompare size={16} />,
          title: "Intersection Analysis",
          text: "Analyze  spatial layers......",
        },


      ],
    },

    {
      color: "orange",
      icon: <Puzzle />,
      title: "ABPAS ",
      // desc: "ABPAS connectivity and integration tools",

      modules: [
        {
          id: 124,
          icon: <Link size={16} />,
          title: "ABPAS Analysis",
          text: "Access ABPAS system directly.......",
        },

        {
          id: 125,
          icon: <Plug size={16} />,
          title: "ABPAS  NOC Integration ",
          text: "ABPAS Integration with Gis Layers ...",
        },
      ],
    },

    {
      color: "pink",
      icon: <CloudRain />,
      title: "Predictive Analysis",
      // desc: "AI/ML based predictive GIS analysis",

      modules: [
        {
          id: 126,
          icon: <Droplets size={16} />,
          title: "Flood Analysis",
          text: "Flood risk and impact assessment",
        },
        {
          id: 127,
          icon: <Plug size={16} />,
          title: "Map Point Dist",
          text: "MAP Point Dist",
        },

        {
          id: 128,
          icon: <Plug size={16} />,
          title: "Simhasth Project Monitoring",
          text: "GIS Utilities",
        },


        // {
        //   id: 129,
        //   icon: <Plug size={16} />,
        //   title: "Advanced Query Builder ",
        //   text:  "GIS Utilities",
        // },
      ],
    },
  ];


  return (
    <div className="DBTools">
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end"
        }}
      >

      </div>
      <div
        style={{
          color: "#fff",
          background: "#fff",
          margin: "20px auto",
          width: "100%",
          borderRadius: "14px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          boxShadow: "0 4px 18px rgba(0,0,0,0.25)",
          border: "1px solid rgba(255,255,255,0.08)",
          position: "relative",
          overflow: "hidden",
        }}
      >
        {/* Glow Effect */}
        <img
          src="img/mp-garud-new.jpeg"
          alt="MP Garud"
          style={{
            background: "transparent"
          }}
        />

        <h1
          style={{
            margin: 0,
            fontSize: "32px",
            fontWeight: "600",
            letterSpacing: "1.5px",
            background: "linear-gradient(90deg, #38bdf8, #22c55e)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            textTransform: "uppercase",
            zIndex: 1,
            width: "100%",
          }}
        >
          Urban Data Analytics Center - GIS based
        </h1>
      </div>

      <div className="DBcards">
        {cards.map((card, index) => (
          <div className={`card ${card.color}`} key={index}>
            {/* TOP */}
            <div
              className="card-top"
              style={{
                background:
                  card.color === "blue"
                    ? "linear-gradient(135deg,#0c788e,#05876f,#066d63)"
                    : card.color === "purple"
                      ? " linear-gradient(135deg,#51632d,#035268,#4cafcd)"
                      : card.color === "green"
                        ? "linear-gradient(135deg,#047857,#10b981,#2dd4bf)"
                        : card.color === "orange"
                          ? "linear-gradient(135deg,#097763,#137c99,#037f49)"
                          : "linear-gradient(135deg,#0eb496,#068479,#08b46a)",

                padding: "14px",
                borderRadius: "14px",
              }}
            >
              <div className="icon">
                {card.icon}
              </div>

              <div>
                <h3>{card.title}</h3>
                <p>{card.desc}</p>
              </div>
            </div>

            {/* MODULES */}
            <div className="module-list">
              {card.modules.map((module, i) => (
                <div
                  className="module animate-module"
                  key={i}
                  style={{ animationDelay: `${i * 0.12}s` }} // smoother delay
                  onClick={() => handleClick(module)}
                >
                  <div className="module-left">
                    <div className="module-icon">{module.icon}</div>
                    <div className="module-text">
                      <h3>  {module.title}</h3>
                      <span>{module.text}</span>
                    </div>
                  </div>

                  <div className="arrow">
                    <ChevronRight size={22} />
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}

      </div>

      {/* Bottom Layout*/}

      <div className="dashboard-container">

        {/* HEADER */}
        <h2 className="top-header">
          MP GARUD – Department Integration | GIS Tools & Utilities
        </h2>

        {/* MODULE CARDS */}

        <div className="bottom-dashboard">


          {/* CODE FOR CARD*/}
          <div className="bottom-dashboard" style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))",
            gap: "20px",
            padding: "20px"
          }}>

            {modules.map((item, index) => (
              <div
                key={index}
                className="animate-card"
                style={{
                  animationDelay: `${index * 0.15}s`,
                  /* CARD STYLE */
                  background: "linear-gradient(90deg, #4db8a6, #09cbc1)",
                  borderRadius: "12px",
                  padding: "15px",
                  textAlign: "center",
                  cursor: "pointer",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",

                  minHeight: "140px",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                  transition: "0.3s"
                }}

                onClick={() => {
                  if (index === 0) window.open("#", "_blank");
                  else if (index === 1) window.open("#", "_blank");
                  else if (index === 2) window.open("#", "_blank");
                  else if (index === 3) window.open("#", "_blank");
                  else if (index === 4) window.open("#", "_blank");
                }}
              >
                <img
                  src={item.img}
                  alt={item.title}
                  style={{ width: "100%", height: "100%", objectFit: "contain" }}
                />

                <h4 style={{
                  marginTop: "10px",
                  fontSize: "14px",
                  fontWeight: "600"
                }}>
                  {item.title}
                </h4>

              </div>
            ))}

          </div>
          {/* CODE FOR CARD*/}
          {/* CODE FOR Section  BOTTOM*/}
          <div className="feature-section">

            {/* LEFT SIDE */}
            <div className="feature-left">
              <h2>
                Features That Empower Your <br />
                <span>GIS Experience</span>
              </h2>
              <p>
                Explore, analyze, and visualize like never before with cutting-edge tools
                and seamless integration.
              </p>

            </div>

            {/* RIGHT SIDE */}
            <div className="feature-right">

              <div className="feature-card" style={{
                background: "linear-gradient(90deg, #24e1d1, #09cbc1)",
                borderRadius: "12px",
                padding: "15px",
                textAlign: "center",
                cursor: "pointer",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",

                minHeight: "140px",
                boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                transition: "0.3s"
              }}  >GIS Dashboard</div>
              <div className="feature-card" style={{
                background: "linear-gradient(90deg, #24e1d1, #09cbc1)",
                borderRadius: "12px",
                padding: "15px",
                textAlign: "center",
                cursor: "pointer",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",

                minHeight: "140px",
                boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                transition: "0.3s"
              }} >MIS Dashboard</div>
              <div className="feature-card" style={{
                background: "linear-gradient(90deg, #24e1d1, #09cbc1)",
                borderRadius: "12px",
                padding: "15px",
                textAlign: "center",
                cursor: "pointer",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",

                minHeight: "140px",
                boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                transition: "0.3s"
              }} >Spatial Analysis</div>
              <div className="feature-card" style={{
                background: "linear-gradient(90deg, #24e1d1, #09cbc1)",
                borderRadius: "12px",
                padding: "15px",
                textAlign: "center",
                cursor: "pointer",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",

                minHeight: "140px",
                boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                transition: "0.3s"
              }} >Decision  Support System</div>

            </div>
            <div
              style={{
                backgroundImage: "url('/img/Bottom2.png')",
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat"
              }}
            >

            </div>
          </div>
          {/* CODE FOR Section  BOTTOM*/}


        </div>


      </div>
      {/* Bottom Layout*/}


      <Footer />
      {/* Glow Effect */}


    </div>
  );
}
